export const supplierListSelector = state => state.supplierReducer.supplierList;

export const loadingSuppliersSelector = state => state.supplierReducer.loadingSuppliers;
